import { ReactNode, useEffect, useState } from 'react';

interface PopupContainerProps {
  children: ReactNode;
  className?: string;
}

const PopupContainer = ({ children, className = '' }: PopupContainerProps) => {
  const [isHeightLessThan864, setIsHeightLessThan864] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsHeightLessThan864(window.innerHeight < 864);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const headerHeight = document.querySelector("header")?.clientHeight || 0;
    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
  }, []);

  return (
    <div
      className={`
        max-w-[552px] mx-auto flex justify-center
        ${isHeightLessThan864
          ? 'h-auto px-4 py-8'
          : 'h-[calc(100vh-var(--header-height,80px))] py-0'
        }
        ${className}
      `}
      tabIndex={0}
    >
      <div
        className={`
          max-w-[800px] p-2 sm:p-5 md:p-5 lg:p-5 xl:p-5 rounded-3xl
          shadow-[0px_5px_15px_rgba(0,0,0,0.1)]
          flex flex-col items-center text-center
          h-fit w-full relative
          border border-solid border-primary-40 dark:border-primary-90
          ${isHeightLessThan864 ? 'top-0' : 'top-[15%]'}
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default PopupContainer;